import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import classNames from 'classnames';
import hasRequiredPermissions from '../../helpers/hocs/has-required-permissions';

import Headline from '../ui/headline';
import HeadlineDatePicker from '../ui/headline-datepicker';
import LegendFilter from './legendfilter';
import AddBtn from '../../components/ui/add-event-btn';

class CalendarHeader extends Component {
    componentWillReceiveProps(nextProps) {
        if (
            this.props.focus !== nextProps.focus ||
            this.props.view !== nextProps.view
        ) {
            const nextFocus = moment(nextProps.focus);
            const beforeStart = this.props.eventWindowStart
                .clone()
                .add(1, nextProps.view);
            const afterEnd = this.props.eventWindowEnd
                .clone()
                .subtract(1, nextProps.view);
            if (nextFocus.isBefore(beforeStart)) {
                const newStart = this.props.eventWindowStart
                    .clone()
                    .subtract(45, 'day');
                const paramObj = {
                    startDate: newStart.format('YYYY-MM-DD'),
                    endDate: this.props.eventWindowStart
                        .clone()
                        .subtract(1, 'day')
                        .format('YYYY-MM-DD')
                };
                this.props.fetchCalendarThunk(paramObj);
                this.props.setEventWindowStart(newStart);
            } else if (nextFocus.isAfter(afterEnd)) {
                const newEnd = this.props.eventWindowEnd.clone().add(45, 'day');
                const paramObj = {
                    startDate: this.props.eventWindowEnd
                        .clone()
                        .add(1, 'day')
                        .format('YYYY-MM-DD'),
                    endDate: newEnd.format('YYYY-MM-DD')
                };
                this.props.fetchCalendarThunk(paramObj);
                this.props.setEventWindowEnd(newEnd);
            }
        }
    }

    handleChange = e => {
        console.log(e);
        const date = e.toDate();
        const stringDate = date.toString();
        this.props.setFocusDateDirect(stringDate);
        this.props.setCalendarView('day');
        console.log(stringDate);
    };

    render() {
        const formats = {
            day: 'MMMM DD',
            week: 'MMM DD',
            month: 'MMMM'
        };

        let calTitle = moment(this.props.focus).format(
            formats[this.props.view]
        );

        if (formats[this.props.view] === 'MMM DD') {
            let nextWeek = moment(this.props.focus)
                .endOf('week')
                .format(formats[this.props.view]);
            calTitle =
                moment(this.props.focus)
                    .startOf('week')
                    .format(formats[this.props.view]) +
                ' - ' +
                nextWeek;
        }

        const AddEventBtn = hasRequiredPermissions({ Event: ['Create'] })(
            AddBtn
        );

        return (
            <div className="rbc-calendar">
                <div className="rbc-calendar__button">
                    <div className="rbc-calendar__button-view">
                        <button
                            onClick={this.props.toggleCalendarFilters}
                            className={classNames(
                                'panel__link',
                                'panel__link--calendar-filter',
                                {
                                    'is-active': this.props
                                        .calendarFiltersActive
                                }
                            )}
                        >
                            <svg className="icon icon-filter">
                                <use xlinkHref="#icon-filter" />
                            </svg>
                        </button>
                        {this.props.calendarToggle ? (
                            <span>
                                <button
                                    className={classNames(
                                        'rbc-calendar__button-link rbc-calendar__button-link--monthView',
                                        { 'is-active': this.props.calendar }
                                    )}
                                    onClick={() =>
                                        this.props.setCalendarActive(true)
                                    }
                                    value="month"
                                >
                                    <svg className="icon icon-calendar">
                                        <use xlinkHref="#icon-calendar" />
                                    </svg>
                                </button>
                                <button
                                    className={classNames(
                                        'rbc-calendar__button-link rbc-calendar__button-link--monthListView',
                                        { 'is-active': !this.props.calendar }
                                    )}
                                    onClick={() =>
                                        this.props.setCalendarActive(false)
                                    }
                                    value="agenda"
                                >
                                    <svg className="icon icon-ordered-list">
                                        <use xlinkHref="#icon-ordered-list" />
                                    </svg>
                                </button>
                            </span>
                        ) : null}
                    </div>

                    {AddEventBtn && <AddEventBtn />}
                </div>

                <div className={'rbc-calendar__controls'}>
                    <div className={'rbc-calendar__controls--prev'}>
                        <span
                            className={'rbc-icon rbc-icon-left-single-triangle'}
                            onClick={() =>
                                this.props.setFocusDate(
                                    'previous',
                                    this.props.view
                                )
                            }
                        />
                    </div>

                    <div className={'rbc-calendar__controls--date'}>
                        <DatePicker
                            customInput={<HeadlineDatePicker />}
                            dateFormat="YYYY-MM-DD"
                            onChange={this.handleChange}
                            onFocus={this.onFocus}
                            value={calTitle}
                            readOnly
                            showMonthDropdown
                            showYearDropdown
                            minDate={moment().subtract(2, 'years')}
                            maxDate={moment().add(3, 'years')}
                            dropdownMode="select"
                            openToDate={moment(this.props.focus)}
                        />
                        <Headline
                            title={moment(this.props.focus).format('YYYY')}
                            tagValue="5"
                        />
                    </div>

                    <div className={'rbc-calendar__controls--next'}>
                        <span
                            className={
                                'rbc-icon rbc-icon-right-single-triangle'
                            }
                            onClick={() =>
                                this.props.setFocusDate('next', this.props.view)
                            }
                        />
                    </div>
                </div>

                <div className="rbc-calendar__heading">
                    <div className="rbc-calendar__controls">
                        <button
                            className={classNames('fc-button', {
                                'rbc-state-active': this.props.view === 'day'
                            })}
                            onClick={() => this.props.setCalendarView('day')}
                        >
                            Day
                        </button>
                        <br />
                        <button
                            className={classNames('fc-button', {
                                'rbc-state-active': this.props.view === 'week'
                            })}
                            onClick={() => this.props.setCalendarView('week')}
                        >
                            Week
                        </button>
                        <br />
                        <button
                            className={classNames('fc-button', {
                                'rbc-state-active': this.props.view === 'month'
                            })}
                            onClick={() => this.props.setCalendarView('month')}
                        >
                            Month
                        </button>
                    </div>
                </div>

                <LegendFilter
                    filters={this.props.filters}
                    toggleFilter={this.props.toggleFilter}
                />
            </div>
        );
    }
}

export default CalendarHeader;



// WEBPACK FOOTER //
// ./src/components/calendar/header.js